import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BaseDialogDefinition, ValueCalculator} from '@aviary/dialogs/base-dialog/base-dialog.types';
import {
  ConfirmationDialogDefinition,
  DEFAULT_CONFIRMATION_CANCEL_BUTTON_LABEL,
  DEFAULT_CONFIRMATION_CONFIRM_BUTTON_LABEL,
  DEFAULT_CONFIRMATION_VALUE_CALCULATOR
} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {BaseDialogComponent} from '@aviary/dialogs/base-dialog/base-dialog.component';

@Component({
  selector: 'mx-confirmation-dialog',
  host: {
    class: 'hk-delegate-vertical-scrolling grow'
  },
  template: `
    <mx-base-dialog [definition]="baseDialogDefinition"
                    [showCancelButton]="showCancelButton"
                    [showConfirmButton]="showConfirmButton"
                    [enableConfirmButton]="enableConfirmButton"
                    [showAdditionalActionButtons]="showAdditionalActionButtons"
                    [additionalButtonsAreConfirm]="additionalButtonsAreConfirm">
      <ng-content/>

      <ng-container additionalActionButtons>
        <ng-content select="[additionalActionButtons]"/>
      </ng-container>
    </mx-base-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseDialogComponent]
})
export class ConfirmationDialogComponent<ValueType> {

  @Input()
  public set definition(definition: ConfirmationDialogDefinition<ValueType>) {
    this.baseDialogDefinition = {
      cancelButtonLabel: DEFAULT_CONFIRMATION_CANCEL_BUTTON_LABEL,
      confirmButtonLabel: DEFAULT_CONFIRMATION_CONFIRM_BUTTON_LABEL,
      valueCalculator: DEFAULT_CONFIRMATION_VALUE_CALCULATOR as unknown as ValueCalculator<ValueType>,
      ...definition
    };
  }

  @Input() public showCancelButton: boolean = true;
  @Input() public showConfirmButton: boolean = true;
  @Input() public enableConfirmButton: boolean = true;
  @Input() public showAdditionalActionButtons: boolean = false;
  @Input() public additionalButtonsAreConfirm: boolean = false;

  public baseDialogDefinition: BaseDialogDefinition<ValueType>;
}
